import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import 'vuetify/dist/vuetify.min.css'
// Importa a máscara de input
import VueTheMask from 'vue-the-mask'
// Importa a instância configurada do Vuetify
import vuetify from './plugins/vuetify'
// Importa os outros plugins (agora sem o Vuetify)
import './plugins'

import './components/core'

import App from './App.vue'
import router from './router'
import store from './store'
import './utils/filters'
import './mixins/index'
import { auth, api } from '@/store/firebase'
import moment from 'moment-timezone'
import 'moment/locale/pt-br'

// 🔥 SISTEMA DE TRATAMENTO DE ERROS CENTRALIZADO
import { installErrorHandler } from '@/services/errorHandlingService'

// 🔒 Disponibilizar store globalmente para filtros Vue.js
if (typeof window !== 'undefined') {
  window.store = store
}

Vue.config.productionTip = false

Vue.use(VueTheMask)
moment.locale('pt-br')
moment.tz.setDefault('America/Sao_Paulo')
Vue.prototype.$moment = moment

// 🌐 Configurar instância HTTP global
Vue.prototype.$http = api

// 🔔 Registrar Service Worker para Push Notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registrado:', registration.scope)

        // Verificar se há atualizações
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          console.log('🔄 Nova versão do Service Worker encontrada')

          newWorker.addEventListener('statechange', () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              console.log('🔄 Service Worker atualizado, recarregando...')
              window.location.reload()
            }
          })
        })
      })
      .catch((error) => {
        console.error('❌ Erro ao registrar Service Worker:', error)
      })
  })
}
// 🔥 Instalar handler global de erros
installErrorHandler(Vue)

// Verificar e depurar o router
if (!router) {
  console.error('Erro crítico: Vue Router é null. Verifique ./router.js e dependências.')
  console.log('Dependências do projeto:', {
    Vue: Vue.version,
    'vue-router': require('vue-router/package.json').version
  })
  throw new Error('Vue Router não inicializado')
} else {
  console.log('Router importado:', router)
  if (typeof router === 'object' && !router._routerRoot) {
    console.warn('Atenção: O roteador pode não ser uma instância válida do Vue Router.')
  }
}

let app

auth.onAuthStateChanged((user) => {
  if (!app) {
    // Criar e usar o roteador antes de montar a aplicação
    const vueApp = new Vue({
      vuetify,
      router, // Passar o router para a instância
      store,
      render: (h) => h(App)
    })

    // Tentar usar o roteador apenas se for válido (comente por agora)
    // if (router && typeof router.use === 'function') {
    //   vueApp.use(router)
    // } else {
    //   console.error('Erro: Não é possível usar o roteador. Router inválido:', router)
    // }

    // Montar a aplicação
    vueApp.$mount('#app')

    // Disponibilizar globalmente para NotificationService
    window.app = vueApp

    app = vueApp
  }
})
